import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import availableEmojis from "../../queries/availableEmojis.gql";
import Emoji from "../Emoji/Emoji";
import { Query } from "react-apollo";
import { colors } from "../../theme";

import Loading from "../Loading/Loading";

const EmojiContainer = styled.div`
  display: block;
  margin-left: 0px;
`;

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;

  border-top: 10px solid ${colors.line};
`;

const EmojiPopup = styled.div`
  position: absolute;
  z-index: 12;
  background-color: white;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 370px;
  transition: all ease-out 0.7s;
  overflow: hidden;
  max-height: ${props => (props.open ? "100%" : "0px")};
`;

const EmojiPickerSelected = styled.a`
  font-size: ${props => (props.size ? props.size : "32px")};
  border: 1px solid ${colors.line};
  margin-right: 35px;
  height: ${props =>
    props.size ? `${Math.round(props.size * 1.5)}px` : "48px"};
  display: flex;
  justify-content: space-between;
  padding: 5px 15px;
  align-items: center;
  text-decoration: none;
`;

const EmojiDiv = styled.a`
  font-size: ${props => (props.size ? props.size : "32px")};
  padding: 5px;
  margin: 5px;
  cursor: pointer;
  transition: all 0.2s;
  display: block;
  text-decoration: none;

  &:hover {
    background-color: #efefef;
  }
`;

class EmojiPicker extends PureComponent {
  static propTypes = {
    topics: PropTypes.object,
    onSelect: PropTypes.func,
    defaultValue: PropTypes.string,
    size: PropTypes.number
  };

  state = {
    selected: null,
    open: false
  };

  static getDerivedStateFromProps(props, state) {
    if (true) {
      return {
        ...state,
        selected: props.defaultValue
      };
    }
    return state;
  }

  _setSelected(emoji, e) {
    const { onSelect } = this.props;

    e.preventDefault();

    this.setState({ selected: emoji, open: false });
    if (onSelect) {
      onSelect(emoji);
    }
  }

  toggle(e) {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  }

  render() {
    const { selected, open } = this.state;

    return (
      <Query query={availableEmojis}>
        {({ loading, error, data }) => {
          if (loading) return <Loading inline={true} />;
          if (error) return null;

          return (
            <EmojiContainer>
              <EmojiPickerSelected onClick={e => this.toggle(e)} href="#">
                {selected ? <Emoji>{selected}</Emoji> : <span />} <Triangle />
              </EmojiPickerSelected>

              <EmojiPopup open={open}>
                {data.availableEmojis.map(emoji => (
                  <EmojiDiv
                    selected={selected === emoji}
                    key={`emoji-${emoji}`}
                    onClick={e => this._setSelected(emoji, e)}
                    href="#"
                  >
                    <Emoji>{emoji}</Emoji>
                  </EmojiDiv>
                ))}
              </EmojiPopup>
            </EmojiContainer>
          );
        }}
      </Query>
    );
  }
}

export { EmojiPicker };



// WEBPACK FOOTER //
// ./src/components/EmojiPicker/EmojiPicker.js